import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpStructure } from './help-shell/help-shell.component';
import { HelpService } from './help.service';

@Component({
  selector: 'epp-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent<T extends object> implements OnInit {
  @Input() title = 'è¯·éæ©'
  @Input() placeholder = this.translate.translations[this.translate.currentLang]['pleaseSelect']
  @Input() structure = HelpStructure.table
  @Input() getData
  @Input() tableFields = ['name']
  @Input() displayField = 'name'
  @Input() getTableOnSelectTree
  // @Input() initialDisplay
  @Input() display: string
  @Input() expandedKeys: string[]

  selectedItem: T
  @Output() selectedItemChange = new EventEmitter<T>()

  constructor (
    private help: HelpService,
    private cd: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit () {
  }

  handleClickOpenHelp () {
    this.help.show<T>({
      title: this.title,
      structure: this.structure,
      getData: this.getData,
      tableFields: this.tableFields,
      getTableOnSelectTree: this.getTableOnSelectTree,
      expandedKeys: this.expandedKeys
    }).subscribe((item: T) => {
      // console.log(item)
      this.selectedItem = item
      this.selectedItemChange.emit(item)
      this.display = item[this.displayField]
      // this.selectedItemIdChange.emit(item.id)
      this.cd.markForCheck()
    })
  }

}
